"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.PriorityPill = exports.FWIconContainer = exports.PillContainer = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var styled_1 = require("@hiyllo/ux/styled");
var react_native_1 = require("react-native");
var omni_continuity_1 = require("@hiyllo/omni-continuity");
var platform_1 = require("@hiyllo/ux/platform");
var use_priorities_1 = require("../hooks/use-priorities");
var select_1 = require("@hiyllo/ux/select");
var priority_1 = require("../consts/priority");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var PRIORITY_OPTIONS = [
    {
        icon: priority_1.PriorityIconsMap[0],
        label: "P0",
        value: 0
    },
    {
        icon: priority_1.PriorityIconsMap[1],
        label: "P1",
        value: 1
    },
    {
        icon: priority_1.PriorityIconsMap[2],
        label: "P2",
        value: 2
    },
    {
        icon: priority_1.PriorityIconsMap[3],
        label: "P3",
        value: 3
    },
    {
        icon: priority_1.PriorityIconsMap[4],
        label: "P4",
        value: 4
    },
];
exports.PillContainer = (0, styled_1.styledRN)(react_native_1.View, function (_a) {
    var $theme = _a.$theme, bg = _a.bg;
    return ({
        padding: 5,
        backgroundColor: bg !== null && bg !== void 0 ? bg : $theme.midground,
        height: 25,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        borderRadius: 5,
        paddingLeft: 7.5,
        paddingRight: 7.5
    });
});
exports.FWIconContainer = (0, styled_1.styledRN)(react_native_1.View, function (_a) {
    var changeable = _a.changeable;
    return ({
        width: changeable ? 27.5 : 17.5,
        display: 'flex',
        flexDirection: 'row',
        gap: 2.5,
        justifyContent: 'center',
        alignItems: 'center'
    });
});
exports.PriorityPill = react_1["default"].memo(function PriorityPill(_a) {
    var priority = _a.priority, onChangePriority = _a.onChangePriority;
    var FontAwesomeIcon = (0, platform_1.useFontAwesomeIcon)();
    var isSolo = (0, omni_continuity_1.useEnvironment)().isSolo;
    var _b = (0, use_priorities_1.usePriorities)({
        variant: isSolo ? 'solo' : 'work'
    }), icons = _b.icons, colors = _b.colors;
    var icon = icons[priority];
    var color = colors[priority];
    return ((0, jsx_runtime_1.jsx)(select_1.Select, { options: PRIORITY_OPTIONS, value: priority, disabled: onChangePriority === null, onChangeValue: onChangePriority != null
            ? function (v) { return onChangePriority(v); }
            : undefined, containerStyle: { width: "min-content" }, customStaticElement: (0, jsx_runtime_1.jsx)(exports.PillContainer, __assign({ bg: color }, { children: (0, jsx_runtime_1.jsxs)(exports.FWIconContainer, __assign({ changeable: onChangePriority != null }, { children: [(0, jsx_runtime_1.jsx)(FontAwesomeIcon, { icon: icon, color: "white", size: 12 }), onChangePriority != null ? ((0, jsx_runtime_1.jsx)(FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faCaretDown, color: "white" })) : null] })) })) }));
});
